import * as _ from 'lodash';
import moment from 'moment';
import { Platform } from 'react-native';
import { Util as CoreUtil} from 'opidcore';


export class Util {

	// could really be a browser dimension or somthing
	static parseSize(width) {
		// for now expect it to be a px string, but later we want % and em to be accepted
		return parseInt(width);

	}
	static currency(value) {
		return CoreUtil.currency(value);
	}

	static isMobile = () => {
		return Platform.OS != "web";
	}

	static isDev = ()=>{
		return __DEV__;
		//return window && window.location &&  window.location.href && window.location.href.indexOf('localhost') >= 0
	}

	static getHost = () => {
		var host = "";

		if (Util.isDev()) {
			host = 'http://127.0.0.1:9000';
		} else if (window.location.hostname != null && window.location.hostname.length > 0) {
			host = "https://" + window.location.hostname;
		} else {
			host = "https://hostundefined";
		}
		return host;
	}


	static round(num, places){
		return CoreUtil.round(num, places);
	}
	
	static roundNice(num, places){
		return CoreUtil.roundNice(num, places);
	}

	static stringify(data) {
		return CoreUtil.stringify(data)
	}

	static hash(str) {
		var hash = 0;

		if (typeof str == "object") {

			return Util.hash(Util.stringify(str));
		}

		if (typeof str == "function") {

			return "function";
		}

		if (str == undefined || str.length == 0) return hash;

		for (var i = 0; i < str.length; i++) {
			var char = str.charCodeAt(i);
			hash = ((hash << 5) - hash) + char;
			hash = hash & hash; // Convert to 32bit integer
		}

		return hash;
	}

	//thanks @jvanderberg
	static objectDifference(object, base) {
		return CoreUtil.objectDifference(object, base);
	}


	static deepMap(obj, iter) {
		return _.transform(obj, (result, value, key) => {
			result[key] = iter(value, key) == true ? (_.isObject(value) ? Util.deepMap(value, iter) : value) : null;
		});
	}

	static OpidMerge(obj, src) {
		const mergeHelper = (objValue, srcValue) => {
			if (objValue === undefined) {
				return srcValue;
			} else if (_.isPlainObject(objValue)) {
				return _.mergeWith({}, objValue, srcValue, mergeHelper);
			} else if (Array.isArray(objValue)) {
				return [...srcValue];
			}
		}

		_.mergeWith(obj, src, mergeHelper);
	}

	static capitalizeWord = (word) => {
		if (word.length == 0) {
			return "";
		}

		if (word.length < 2) {
			return word[0].toUpperCase();
		}

		return word[0].toUpperCase() + word.substring(1, word.length);
	}

	static capitalizeWords = (words, splitString) => {
		if (Array.isArray(words)) {
			_.map(words, (s) => Util.capitalizeWord(s)).join(" ");
		}

		return _.map(words.split(splitString), (s) => Util.capitalizeWord(s)).join(" ");
	}

	static isBaseEntity = (b) => {
		return b.__type != null;
	}

	static containsBaseEntity = (things, b) => {
		return _.filter(things, (t) => {
			return t.__type == b.__type && t.id == b.id
		}).length > 0
	}

	static findBaseEntity = (things, b) => {
		return _.first(_.filter(things, (t) => {
			return t != null && t.__type == b.__type && t.id == b.id
		}));
	}

	static isSameAs = (a, b) => {
		return a.__type == b.__type && a.id == b.id
	}

	static addTerm = (date, term) => {
		const origDate = moment(date);
		const momentDate = moment(date);
		momentDate.add(term, "month");
		if (origDate.date() <= momentDate.date()) {
			momentDate.subtract("day", 1);
		}
		return momentDate;
	}

	static isNumber(val){
		return !isNaN(parseInt(val));
	}
};

export default Util;